import type {
  UnknownAsyncThunkFulfilledAction,
  UnknownAsyncThunkPendingAction,
  UnknownAsyncThunkRejectedAction,
  // eslint-disable-next-line import/no-unresolved
} from '@reduxjs/toolkit/dist/matchers'
import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import stringify from 'fast-json-stable-stringify'
import type { AppState } from 'state'
import { fetchPublicXpMerchant } from './fetchXpMerchant'


import { SerializedXpMerchantState, SerializedXpMerchant } from '../types'

const noDataXpMerchantConfig = {
  xpBalance: '0'
}

const initialState: SerializedXpMerchantState = {
  data: noDataXpMerchantConfig,
  loadArchivedXpMerchantData: false,
  dataLoaded: false,
  loadingKeys: {},
}

// Async thunks
export const fetchXpMerchantPublicDataAsync = createAsyncThunk<
  SerializedXpMerchant,
  string,
  {
    state: AppState
  }
>(
  'xpMerchant/fetchXpMerchantPublicDataAsync',
  async ( x ) => {

    const payload = await fetchPublicXpMerchant()

    return payload
  },
  {
    condition: (arg, { getState }) => {
      const { xpMerchant } = getState()
      if (xpMerchant.loadingKeys[stringify({ type: fetchXpMerchantPublicDataAsync.typePrefix, arg })]) {
        console.debug('xpMerchant action is fetching, skipping here')
        return false
      }
      return true
    },
  },
)

type UnknownAsyncThunkFulfilledOrPendingAction =
  | UnknownAsyncThunkFulfilledAction
  | UnknownAsyncThunkPendingAction
  | UnknownAsyncThunkRejectedAction

const serializeLoadingKey = (
  action: UnknownAsyncThunkFulfilledOrPendingAction,
  suffix: UnknownAsyncThunkFulfilledOrPendingAction['meta']['requestStatus'],
) => {
  const type = action.type.split(`/${suffix}`)[0]
  return stringify({
    arg: action.meta.arg,
    type,
  })
}

export const xpMerchantSlice = createSlice({
  name: 'XpMerchant',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Update xpMerchant with live data
    builder.addCase(fetchXpMerchantPublicDataAsync.fulfilled, (state, action) => {
      state.data.xpBalance = action.payload.xpBalance
    })

  },
})

export default xpMerchantSlice.reducer
